import { FormStore } from "@modules/formx";
import { LookupItem } from "@containers";
import { ConsultantFormData } from "./consultant-edit-form";

export function applyLookupResult(
  form: FormStore<ConsultantFormData>,
  data: LookupItem[]
) {
  for (const item of data) {
    const { field, newValue } = item;

    switch (field) {
      case "AddressCity":
        form.values.address.city = newValue;
        break;
      case "AddressCountry":
        form.values.address.country = newValue;
        break;
      case "AddressStreetName":
        form.values.address.streetName = newValue;
        break;
      case "AddressZipCode":
        form.values.address.zipCode = newValue;
        break;
      case "CellPhone":
        form.values.contacts.cellPhone = newValue;
        break;
      case "FirstName":
        form.values.personal.firstName = newValue;
        break;
      case "LastName":
        form.values.personal.lastName = newValue;
        break;
      case "Phone":
        form.values.contacts.phone = newValue;
        break;
    }
  }

  form.validate();
}
